import React, { useRef, useState } from "react";
import { ImageUp } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function BundlePictureButton({ product, onSaved }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) { return; }
    if (!/^image\/(jpeg|png|webp)$/.test(file.type) || file.size > 5 * 1024 * 1024) { toast.error("Picture must be a JPG, PNG or WEBP under 5 MB"); return; }
    if (!window.confirm(`Replace the picture of "${product.title}" in TedOps AND on the /shop/ website?`)) { return; }
    const rd = new FileReader();
    rd.onload = async () => {
      setBusy(true);
      try {
        await api.put(`/new-catalogue/bundle-web-push/bundles/${product.legacy_id}/image`, { confirm: true, image_data: rd.result }, { timeout: 120000 });
        toast.success("Picture updated in TedOps and on the website");
        if (onSaved) { onSaved(); }
      } catch (err) { toast.error(err.response?.data?.detail || "Could not change the picture"); } finally { setBusy(false); }
    };
    rd.readAsDataURL(file);
  };
  if (!product?.bundle?.source_wc_bundle_id) { return null; }
  return (
    <>
      <Button size="sm" variant="outline" disabled={busy} onClick={() => ref.current?.click()} data-testid="bundle-change-picture-btn">
        <ImageUp className="w-4 h-4" /> {busy ? "Uploading…" : "Change picture"}
      </Button>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={pick} data-testid="bundle-change-picture-input" />
    </>
  );
}
